export const notificationTypes = {
  EXPORT_REQUEST_FAILED: 'export_request_failed',
  EXPORT_REQUEST_SUCCESS: 'export_request_success',
  HA_PROFILE_UPDATED: 'ha_profile_updated',
  CLINICIAN_PROFILE_UPDATED: 'clinician_profile_updated',
  CLINICIAN_PROFILE_RECEIVED_FOR_REVIEW:
    'clinician_profile_received_for_review',
  HA_PROFILE_RECEIVED_FOR_REVIEW: 'ha_profile_received_for_review',
  HA_PROFILE_APPROVED: 'ha_profile_approved',
  NEW_MESSAGE_RECEIVED: 'new_message_received',
  DICTIONARY_ATTRIBUTE_ADDED: 'dictionary_attribute_added',
  DICTIONARY_ATTRIBUTE_UPDATED: 'dictionary_attribute_updated',
  NEW_DOCUMENT_TYPE_ADDED: 'new_document_type_added',
  VISIT_DATE_RANGE_EXPIRED: 'visit_date_range_expired',
  VISIT_SCHEDULED_DATE_EXPIRED: 'visit_scheduled_date_expired',
  VISIT_IS_COMPLETED_BY_CLINICIAN: 'visit_is_completed_by_clinician',
  OFFER_REJECTED_BY_CLINICIAN: 'offer_rejected_by_clinician',
  HA_PROFILE_REJECTED: 'ha_profile_rejected',
  CLINICIAN_DOCUMENTS_ZIP_SUCCESS: 'clinician_documents_zip_success',
  CLINICIAN_DOCUMENTS_ZIP_FAILED: 'clinician_documents_zip_failed',
}

export const clickableNotificationTypes = [
  notificationTypes.HA_PROFILE_UPDATED,
  notificationTypes.CLINICIAN_PROFILE_UPDATED,
  notificationTypes.CLINICIAN_PROFILE_RECEIVED_FOR_REVIEW,
  notificationTypes.HA_PROFILE_RECEIVED_FOR_REVIEW,
  notificationTypes.NEW_MESSAGE_RECEIVED,
  notificationTypes.DICTIONARY_ATTRIBUTE_ADDED,
  notificationTypes.DICTIONARY_ATTRIBUTE_UPDATED,
  notificationTypes.NEW_DOCUMENT_TYPE_ADDED,
  notificationTypes.VISIT_DATE_RANGE_EXPIRED,
  notificationTypes.VISIT_SCHEDULED_DATE_EXPIRED,
  notificationTypes.VISIT_IS_COMPLETED_BY_CLINICIAN,
  notificationTypes.OFFER_REJECTED_BY_CLINICIAN,
  notificationTypes.HA_PROFILE_REJECTED,
  notificationTypes.CLINICIAN_DOCUMENTS_ZIP_SUCCESS,
]
